//----------------------------------------------------------------//

bcl.u.breakMobile = 1023;
bcl.u.breakTablet = 605;
bcl.u.breakMobilePlus = 1024;

bcl.u.mobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
  },

  webView: function () {
    return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
  },

  isMobile: function () {
    return window.matchMedia ? window.matchMedia(`(max-width: ${bcl.u.breakMobile}px)`).matches : window.innerWidth <= bcl.u.breakMobile;
  },

  isTablet: function () {
    return window.matchMedia ? window.matchMedia(`(min-width: ${bcl.u.breakTablet}px) and (max-width: ${bcl.u.breakMobile}px)`).matches : window.innerWidth < bcl.u.breakMobilePlus && window.innerWidth >= bcl.u.breakTablet;
  },
};

//----------------------------------------------------------------//
